import React from 'react';
import NextLink from 'next/link';
import { is } from 'ramda';
import { FormattedMessage } from 'react-intl';

import { Artwork } from '@definitions/artworks.types';
import { ROUTE } from '@utils/constants';
import { FavoriteButton } from '@components/favoriteButton';
import { renderWhen } from '@utils/rendering';
import { formatPrice } from '@utils/helpers';

import {
  Container,
  Content,
  ArtworkContainer,
  ImageContainer,
  Image,
  Caption,
  favoriteButtonCustomStyles,
  Price,
  ViewAll,
  ViewAllCopy,
  ArrowRight,
} from './smallArtworkList.styles';

export interface SmallArtworkListProps {
  artworks: Artwork[];
}

export const SmallArtworkList = ({ artworks }: SmallArtworkListProps) => {
  const renderPrice = renderWhen(is(Number), (price: string) => <Price>{formatPrice(price, true)}</Price>);

  return (
    <Container>
      <Content>
        {artworks.map(({ primaryImage, artist, slug, favorite, price }, index) => (
          <NextLink href={`${ROUTE.ARTWORKS}/${artist.slug}/${slug}`} key={index} passHref>
            <ArtworkContainer>
              <ImageContainer>
                <Image src={primaryImage?.urlThumbnail} alt={primaryImage?.description} />
              </ImageContainer>
              <Caption>
                {renderPrice(price)}
                <FavoriteButton
                  slug={slug}
                  favorite={favorite}
                  width={22}
                  height={22}
                  customStyles={favoriteButtonCustomStyles}
                />
              </Caption>
            </ArtworkContainer>
          </NextLink>
        ))}
        <NextLink href={ROUTE.ACCOUNT_FAVORITES} passHref>
          <ViewAll>
            <ViewAllCopy>
              <FormattedMessage id="smallArtworkList.viewAll" defaultMessage="View all" />
              <ArrowRight />
            </ViewAllCopy>
          </ViewAll>
        </NextLink>
      </Content>
    </Container>
  );
};
